import React from 'react';
import { ApplicationView as view } from '@aha-app/mvc';
import ExtensionActionItem from './ExtensionActionItem';

/**
 * @typedef ExtensionActionsGroupProps
 * @prop {{extension: {name: string, identifier: string}, actions: import('./models/RecordAction').default[]}[]} actions
 */

/**
 * @type {React.FC<ExtensionActionsGroupProps>}
 */
const ExtensionActionsGroup = ({ actions }) => {
  return (
    <aha-menu-group label='Extension actions'>
      {actions.flatMap(({ extension, actions }) => (
        <ExtensionActionItem
          key={extension.identifier}
          extension={extension}
          actions={actions}
        />
      ))}
    </aha-menu-group>
  );
};

export default view(ExtensionActionsGroup);
